import { FC } from 'react'
import { useIntl } from 'react-intl'
import { IPickupFeesReportModel } from '../core/_models'
import {storeCurrencyLabel} from '../../common/currencyLabel'

type IProps = {
    item: IPickupFeesReportModel
}

const PickupFeesReportTableRow: FC<IProps> = ({ item }) => {
    const { formatMessage } = useIntl()

    return (
        <tr>
            <td>{item.name}</td>
            <td>{item.po_id}</td>
            <td style={{ color: 'green' }}>{item.fees} {storeCurrencyLabel(formatMessage)}</td>
            <td>{item.date_added}</td>
        </tr>
    )
}

export default PickupFeesReportTableRow
